<template>
  <form class="flex flex-col gap-4" @submit.prevent="submit">
    <p class="text-sm leading-relaxed text-gray-600 dark:text-gray-300">
      Здесь можно задать вопрос техподдержке, предложить улучшение сайта или сообщить о найденной ошибке.
      Выберите тип обращения и опишите ситуацию.
    </p>

    <div>
      <label for="support-form-type" class="mb-1 block text-sm font-medium text-gray-700 dark:text-gray-300">
        Тип обращения
      </label>
      <select
          id="support-form-type"
          v-model="form.type"
          required
          class="w-full rounded-lg border-gray-300 bg-white text-gray-900 focus:border-blue-500 focus:ring-blue-500 dark:border-gray-600 dark:bg-gray-700 dark:text-gray-100"
      >
        <option value="" disabled>Выберите тип обращения</option>
        <option value="support">Вопрос по работе сайта</option>
        <option value="offering">Предложение</option>
        <option value="bug">Сообщение об ошибке</option>
      </select>
    </div>

    <div>
      <label for="support-form-email" class="mb-1 block text-sm font-medium text-gray-700 dark:text-gray-300">
        Email для ответа
      </label>
      <input
          id="support-form-email"
          v-model="form.email"
          type="email"
          required
          autocomplete="email"
          placeholder="you@example.com"
          class="w-full rounded-lg border-gray-300 bg-white text-gray-900 placeholder-gray-400 focus:border-blue-500 focus:ring-blue-500 dark:border-gray-600 dark:bg-gray-700 dark:text-gray-100"
      />
    </div>

    <div>
      <label for="support-form-message" class="mb-1 block text-sm font-medium text-gray-700 dark:text-gray-300">
        Сообщение
      </label>
      <textarea
          id="support-form-message"
          v-model="form.message"
          required
          rows="5"
          placeholder="Напишите, чем мы можем помочь"
          class="w-full resize-y rounded-lg border-gray-300 bg-white text-gray-900 placeholder-gray-400 focus:border-blue-500 focus:ring-blue-500 dark:border-gray-600 dark:bg-gray-700 dark:text-gray-100"
      ></textarea>
    </div>

    <button
        type="submit"
        :disabled="supportStore.sendingForm"
        class="w-full rounded-lg bg-blue-600 px-4 py-2.5 font-medium text-white transition hover:bg-blue-700 disabled:cursor-not-allowed disabled:opacity-60"
    >
      {{ supportStore.sendingForm ? 'Отправляем…' : 'Отправить сообщение' }}
    </button>
  </form>
</template>

<script setup>
import { reactive, watch } from 'vue';
import { useSupportStore } from '@/modules/support/store/supportStore.js';

const props = defineProps({
  initialEmail: {
    type: String,
    default: '',
  },
});

const emit = defineEmits(['submitted']);
const supportStore = useSupportStore();
const form = reactive({
  type: '',
  email: props.initialEmail,
  message: '',
});

watch(() => props.initialEmail, (email) => {
  if (!form.email) form.email = email || '';
});

async function submit() {
  const sent = await supportStore.sendForm(form);
  if (!sent) return;

  form.type = '';
  form.email = props.initialEmail || '';
  form.message = '';
  emit('submitted');
}
</script>
